module.exports = __webpack_public_path__ + "img/takeaway-banner-pc.2cdde137.jpg";